import _isEmpty from 'lodash/isEmpty';
import { isNodeChatAlreadyExists } from './globalHelper';

/**
 * Used as a helper function to validate if window.nodeChat.show() is present, this function is used in conjunction with poll.js
 * @returns {*}
 */

export const nodeChatOnPageValidator = () => {
  if (_isEmpty(window.nodeChat) || typeof window.nodeChat.show !== 'function') {
    return Promise.reject(false);
  }
  return Promise.resolve(window.nodeChat);
};

export const asyncChatValidator = () => {
  if (typeof window.nodeChat === 'undefined' || typeof window.nodeChat.showAsync !== 'function') {
    return Promise.reject();
  }
  return Promise.resolve();
};

export const nodeChatOnWindowValidator = () => {
  if (!isNodeChatAlreadyExists()) {
    return Promise.reject();
  }
  return Promise.resolve();
};
